<template>
<el-row type="flex">
  <el-col :span="20">
    <el-progress :text-inside="true" :stroke-width="14" :percentage="perfPercentage" :color="eventColor" />
  </el-col>
  <el-col :span="4">
    <i v-if="hasMultipleRscKey" class="fas fa-plus" @click="clickButton"style="cursor:pointer;margin-top:3px;margin-left:4px" />
  </el-col>
</el-row>
</template>

<script>
import { isNil } from 'lodash';

export default {
  name: 'WMultipleRscPerfProgressBar',
  props: {
    perfRecords: Object,
    perfKey: String,
    eventTriangle: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      perfValue: 0,
      hasMultipleRscKey: false,
      eventColor: '',
    };
  },
  computed: {
    perfPercentage() {
      if (isNil(this.perfKey)) {
        return 0;
      }
      const perfData = this.perfRecords[this.perfKey];
      // FIXME:  성능 값이 없을 경우 어떻게 표현? 일단 0%으로 표현.
      if (isNil(perfData)) {
        return 0;
      }

      return Number(perfData);
    },
  },
  watch: {
    perfRecords: {
      immediate: true,
      handler(value) {
        // 이벤트 색상 초기화
        this.hasMultipleRscKey = false;
        this.eventColor = '';

        if (isNil(value)) {
          return;
        }
        const record = this.perfRecords;
        const key = this.perfKey;
        const eventInfo = this.$store.getters.eventlevelInfo;

        const eventlevelId = record[`${key}/EVENTLEVEL_ID`];
        if (!isNil(eventlevelId)) {
          this.eventColor = eventInfo[eventlevelId].eventlevelColorBg;
        }
        if (record[`${key}/MULTIPLE`]) {
          this.hasMultipleRscKey = true;
        }
      },
    },
  },
  methods: {
    clickButton() {
      this.$emit('click-button');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/progressbar/MultipleRscPerfProgressBar.vue